import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { splitText } from 'services/string'
import { currency as formatCurrency } from 'services/number'
import { image } from 'services'
import utils from 'services/utils'

import Specifications, { defaultConfig } from 'components/Vip/Specifications'
import { ResponsiveContainer } from 'components/LayoutHelpers'
import { Button, IonIcon, Label } from 'controls'
import ControlLiked from './ControlLiked'

import { maskOpaqueImageStyles, absolutes, aligns } from 'theme/commonStyles'
import styles from './styles'
import { iadProvitionalColors } from 'theme/colors'

const { bedrooms, bathrooms, parkingSpaces, surfaceArea } = defaultConfig

const PropertyInterested = ({
  property,
  isLiked,
  isRejected,
  handleLike,
  handleRejected,
  showOfferButton,
  handleOffer,
  hiddeControlLiked,
  handleSelect,
  isOffered
}) => {
  if (!property || !property.id) {
    return null
  }

  const {
    title,
    address,
    firstImage,
    imagesJson,
    status,
    price: { amount, currency }
  } = property

  const isClaimed = status === 'CLAIMED'
  const hasJsonImage = imagesJson && imagesJson.length > 0;
  const firstJsonImage = hasJsonImage && imagesJson[0].url
  const finalImage = hasJsonImage ? utils.getCroppedImage({file: firstImage || firstJsonImage}) : image('property/defaultproperty.jpg');
  return (
    <div className="property-interested-container">
      <ResponsiveContainer ratio="ratio-16-9">
        <a
          onClick={e => {
            e.preventDefault()
            !isClaimed && handleSelect()
          }}
          className="property-interested-body rounded-corners"
        >
          <div
            className={classnames('mask-opaque-image rounded-corners', {
              'mask-block-image-gray-background': isRejected || isClaimed
            })}
          />
          <img
            className={classnames('main-property-image rounded-corners', {
              'mask-blur-image': isRejected || isClaimed
            })}
            src={finalImage}
            alt={title}
          />

          {!isClaimed && isRejected && (
            <div className="rejected-message nex-absolute-full-with nex-centered-elements">
              <h4 className="title">Propiedad Descartada</h4>
              <p>
                Esta propiedad la marcaste para eliminar, pero no te preocupes,
                puedes activarla nuevamente
              </p>
            </div>
          )}

          {isClaimed && (
            <div className="rejected-message nex-absolute-full-with nex-centered-elements">
              <Label color="text" size="normal" styleType="rounded">
                En proceso de cierre
              </Label>
            </div>
          )}

          {!isClaimed && showOfferButton && (
            <div className="controls-top offer-button">
              {!isOffered ? (
                <Button
                  style={{backgroundColor: iadProvitionalColors.primary}}
                  styleType="rounded"
                  size="tiny"
                  onClick={e => {
                    e.stopPropagation()
                    handleOffer(property)
                  }}
                >
                  <IonIcon style={{marginRight: '0.5rem'}} icon="md-heart" /> Ofertar
                </Button>
              ) : (
                <Label
                  className="offer-success-label"
                  color="purple"
                  size="normal"
                  styleType="rounded"
                >
                  <IonIcon icon="md-happy" size="small" /> Propiedad ofertada
                </Label>
              )}
            </div>
          )}

          {!isClaimed && !hiddeControlLiked && (
            <div className="controls-top controls-liked">
              <ControlLiked
                isLiked={isLiked}
                handleLike={handleLike}
                isRejected={isRejected}
                handleRejected={handleRejected}
              />
            </div>
          )}

          <div className="details">
            <div className="left-details">
              <p className="price">
                {formatCurrency(amount, { currency, currencyDisplay: 'code' })}
              </p>
              <p className="address">{splitText(address, 30)}</p>
            </div>

            <div className="specifications">
              <Specifications
                withWhiteIcon
                property={property}
                config={{ bedrooms, bathrooms, parkingSpaces, surfaceArea }}
                className="small"
              />
            </div>
          </div>
        </a>
      </ResponsiveContainer>
      <style jsx>{absolutes}</style>
      <style jsx>{aligns}</style>
      <style jsx>{maskOpaqueImageStyles}</style>
      <style jsx>{styles}</style>
    </div>
  )
}

PropertyInterested.propTypes = {
  property: PropTypes.object.isRequired,
  isLiked: PropTypes.bool.isRequired,
  isRejected: PropTypes.bool.isRequired,
  handleLike: PropTypes.func.isRequired,
  handleRejected: PropTypes.func.isRequired,
  showOfferButton: PropTypes.bool,
  handleOffer: PropTypes.func
}

export default PropertyInterested
